import { writable } from 'svelte/store';
import SectionPosition from './functions/sectionPosition';

// WARNING: Note any variables declared outside of context() will be instantiated only once on the server. (e.g. GLOBAL)

const context = () => {
    return {
        sectionPosition: new SectionPosition(),
        fussyDependanciesReady: { mainServiceWorkerRegistered: writable(false), oneSignalAPIReady: writable(false) }
    };
};

export default context;
